module.exports = __webpack_public_path__ + "static/media/ET067 new.932afb9f.jpg";